import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ExpenseCategoryForm from "@components/forms/ExpenseCategoryForm";

const ExpenseCategoryAddEdit = () => {
  const params = useParams()
  const { id: expenseCategoryId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!expenseCategoryId ? 'Agregar' : 'Editar'} Categoria de Gastos`}
      backUrl="/user/expenses/categories"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "expenseCategoryForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ExpenseCategoryForm
        formId="expenseCategoryForm"
        id={expenseCategoryId}
        saveRedirectUrl="/user/expenses/categories"
      ></ExpenseCategoryForm>

    </PageContainer>
  );
}

export default ExpenseCategoryAddEdit;
